export const selectGlobalPayments = state => state.globalPayments;
export const selectGlobalPaymentsList = state =>
  selectGlobalPayments(state).items;
export const selectGlobalPaymentsListCount = state =>
  selectGlobalPayments(state).count;
export const selectGlobalPaymentsKpi = state =>
  selectGlobalPayments(state).collectedInRange;
export const selectGlobalPaymentsQueryOptions = state => {
  const { options } = selectGlobalPayments(state);

  Object.keys(options).forEach(key => {
    if (options[key] === '') {
      delete options[key];
    }
  });

  return options;
};
